import React, { useEffect, useState } from 'react';
import { MotionConfig } from 'framer-motion';
import { ColorSchemeBar } from './components/ColorSchemeBar';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { CertificationsBand } from './components/CertificationsBand';
import { ServicesSection } from './components/ServicesSection';
import { GallerySection } from './components/GallerySection';
import { ProcessSection } from './components/ProcessSection';
import { AboutSection } from './components/AboutSection';
import { ReviewsSection } from './components/ReviewsSection';
import { EstimateSection } from './components/EstimateSection';
import { SiteFooter } from './components/SiteFooter';
import { useSmoothAnchorScroll } from './hooks/useSmoothAnchorScroll';
type AppProps = {
  heroTheme?: 'charcoal' | 'plum' | 'steel' | 'light';
  palette?: 'plum' | 'maroon';
  logoColor?: 'auto' | 'purple' | 'black' | 'maroon';
};
const defaultLogoColor = {
  plum: 'purple',
  maroon: 'black'
} as const;
export function App({
  heroTheme = 'plum',
  palette = 'plum',
  logoColor = 'auto'
}: AppProps) {
  const [scheme, setScheme] = useState(palette);
  useSmoothAnchorScroll();
  useEffect(() => {
    setScheme(palette);
  }, [palette]);
  const resolvedLogoColor = logoColor === 'auto' ? defaultLogoColor[scheme] : logoColor;
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="7stfczkdj46">
      <div data-palette={scheme} className="min-h-screen w-full bg-paper font-sans text-ink" data-id="element-1" data-mp="2zlv3gkrj6jqb">
        <ColorSchemeBar value={scheme} onChange={setScheme} data-id="element-2" data-mp="33lwzadal4ixo" />
        <SiteHeader logoColor={resolvedLogoColor} data-id="element-3" data-mp="33oi152avuyvf" />
        <main data-id="element-4" data-mp="38l04bxqkep5n">
          <Hero theme={heroTheme} data-id="element-5" data-mp="38k6wetfvdtlx" />
          <CertificationsBand data-id="element-6" data-mp="3dkuws5pznmst" />
          <ServicesSection data-id="element-7" data-mp="3dl4ktnrh3jvv" />
          <GallerySection data-id="element-8" data-mp="3dmfozootytni" />
          <ProcessSection data-id="element-9" data-mp="3dii5v329623m" />
          <AboutSection data-id="element-10" data-mp="nw2cw89b1us5" />
          <ReviewsSection data-id="element-11" data-mp="nur6s1se0axv" />
          <EstimateSection data-id="element-12" data-mp="nxn69ujvv7of" />
        </main>
        <SiteFooter logoColor={resolvedLogoColor} data-id="element-13" data-mp="su43rfcz2ye6" />
      </div>
    </MotionConfig>;
}